import { GlobalNotificationFacade } from 'src/app/store/global-notification/facade/global-notification.facade';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import * as fromGlobalNotification from './reducers/global-notification.reducer';
import { GlobalNotificationEffects } from './effects/global-notification.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('globalNotification', fromGlobalNotification.GlobalNotificationReducers),
    EffectsModule.forFeature([GlobalNotificationEffects]),
  ],
  providers: [
    GlobalNotificationFacade
  ]
})
export class GlobalNotificationStoreModule {}


